import { format } from "date-fns";

export const useEstimateShipping = (ship_date: string, formatStr: string = "EEEE, LLLL dd") => {
  const { t } = useI18n();

  const estimateShipping = computed(() => {
    return ship_date
      ? format(new Date(ship_date), formatStr)
      : t("shippingDateNotAvailable");
  });

  return {
    estimateShipping,
  };
}
